<template>
  <div>
  </div>
</template>

<script>
export default {
  name: "config-roleSelect",
  props: ['data'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

